module.exports = __webpack_public_path__ + "415fb49c808f8394ff192b0e5569875d.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/ppfPreview/low_110.jpg
// module id = 1728
// module chunks = 5